<template>
  <v-list nav dense>
    <v-img
      :src="
        settings && settings.logo_url
          ? settings.logo_url
          : require('./assets/' +
              $LogoFolder +
              $t('$assets.fullLogoSmallWhite'))
      "
      contain
      width="144"
      class="my-4 ms-8 d-none d-lg-flex"
    />
    <div class="my-1 d-flex d-lg-none" />
    <v-list-item
      v-if="settingMode"
      color="sidebarActive"
      :key="$t('SettingNav.home')"
      @click.stop="$emit('backToHome')"
      link
    >
      <v-list-item-action class="ms-5 me-2">
        <v-icon>fa-home</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="my-n3">
          {{ $t("SettingNav.home") }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <template v-for="item in items">
      <v-list-group
        color="sidebarActive"
        v-if="item.subitems"
        :key="item.title"
        v-model="item.model"
        class="mb-1"
      >
        <template v-slot:activator>
          <v-list-item-action class="ms-5 me-2">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content class="me-n16">
            <v-list-item-title class="me-n16 my-n3">
              <v-badge
                :color="item.badge > 0 ? 'accent' : 'transparent'"
                :label="item.badge > 999 ? '999+' : '' + item.badge"
                :content="item.badge > 999 ? '999+' : item.badge"
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ item.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          color="sidebarActive"
          v-for="(child, i) in item.subitems"
          :key="i"
          v-model="child.model"
          :href="'/#' + child.link"
          link
        >
          <v-list-item-action v-if="child.icon">
            <v-icon>
              {{ child.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="ms-15 my-n3">
              <v-badge
                :color="child.badge > 0 ? 'accent' : 'transparent'"
                :label="child.badge > 999 ? '999+' : '' + child.badge"
                :content="child.badge > 999 ? '999+' : child.badge"
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ child.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item
        color="sidebarActive"
        v-else
        :key="item.title"
        v-model="item.model"
        :href="'/#' + item.link"
        link
      >
        <v-list-item-action class="ms-5 me-2">
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="my-n3">
            <v-badge
              :color="item.badge > 0 ? 'accent' : 'transparent'"
              :label="item.badge > 999 ? '999+' : '' + item.badge"
              :content="item.badge > 999 ? '999+' : item.badge"
              offset-y="10"
              offset-x="0"
              class="my-5"
              >{{ item.title }}
            </v-badge>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<style scoped>
.v-icon.v-icon {
  font-size: 12px;
  width: 20px;
  text-align: center;
}
</style>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import AccountUsers from "@/api/account_users";
import consts from "@/consts";

export default {
  name: "Nav",

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["allow", "settings"]),
  },

  props: {
    settingMode: Boolean,
    login: Object,
    locale: String,
  },

  data: () => ({
    items: [],
  }),

  watch: {
    $route() {
      this.items = this.makeItems();
      AccountUsers.my(true); // 每次路由变化都刷新权限和设置
    },
    settingMode: {
      immediate: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    locale: {
      immediate: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    allow: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    settings: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
  },

  methods: {
    makeItems() {
      var nav = [];
      // nav.push(
      //   Object.assign({}, homeNav, {
      //     model:
      //       this.$route.path == homeNav.link ||
      //       this.$route.path.startsWith(homeNav.link + "/"),
      //   })
      // );
      var navItems = this.settingMode ? this.settingNavs() : this.navs();
      if (this.allow) {
        navItems.forEach((item) => {
          if (item.subitems) {
            var allowedSubitems = [];
            var itemModel = false;
            var itemBadge = 0;
            item.subitems.forEach((subitem) => {
              let controller = this.allow[subitem.controller];
              if (!subitem.controller) {
                subitem.model =
                  this.$route.path == subitem.link ||
                  this.$route.path.startsWith(subitem.link + "/");
                itemModel = itemModel || subitem.model;
                itemBadge += subitem.badge ? subitem.badge : 0;
                allowedSubitems.push(subitem);
              } else if (controller) {
                if (
                  controller.find((action) => subitem.action == action) &&
                  (!subitem.show || subitem.show())
                ) {
                  subitem.model =
                    this.$route.path == subitem.link ||
                    this.$route.path.startsWith(subitem.link + "/");
                  itemModel = itemModel || subitem.model;
                  itemBadge += subitem.badge ? subitem.badge : 0;
                  allowedSubitems.push(subitem);
                }
              }
            });
            if (allowedSubitems.length > 0) {
              item.subitems = allowedSubitems;
              item.model = itemModel;
              item.badge = itemBadge;
              nav.push(item);
            }
          } else {
            if (!item.controller) {
              item.model =
                this.$route.path == item.link ||
                this.$route.path.startsWith(item.link + "/");
              nav.push(item);
            } else {
              let controller = this.allow[item.controller];
              if (controller) {
                if (
                  controller.find((action) => item.action == action) &&
                  (!item.show || item.show())
                ) {
                  item.model =
                    this.$route.path == item.link ||
                    this.$route.path.startsWith(item.link + "/");
                  nav.push(item);
                }
              }
            }
          }
        });
      }
      return nav;
    },
    navs() {
      return [
        {
          title: i18n.t("Nav.account"),
          icon: "fa-file-contract",
          link: "/material-sales",
          subitems: [
            {
              title: i18n.t("Nav.materialSales"),
              // icon: "fa-shopping-basket",
              link: "/material-sales",
              controller: "MaterialSales",
              action: "index",
            },
            {
              title: i18n.t("Nav.materialDailySaleCount"),
              link: "/material-daily-sale",
              controller: "MaterialSales",
              action: "materialDailySaleCount",
            },
            {
              title: i18n.t("Nav.materialDistribution"),
              // icon: "fa-truck",
              link: "/distribution-material-analyze",
              controller: "DistributionMaterialAnalyze",
              action: "index",
            },
            {
              title: i18n.t("Nav.materialExamine"),
              // icon: "fa-truck",
              link: "/examine-material-analyze",
              controller: "ExamineMaterialAnalyze",
              action: "index",
            },
            {
              title: i18n.t("Nav.shopSales", [consts.shopName()]),
              // icon: "fa-store",
              link: "/shop-sales",
              controller: "ShopSales",
              action: "index",
            },
            {
              title: i18n.t("Nav.distributionShopAnalyze", [consts.shopName()]),
              // icon: "fa-truck",
              link: "/distribution-shop-analyze",
              controller: "DistributionShopAnalyze",
              action: "index",
            },
            {
              title: i18n.t("Nav.orderProfit"),
              link: "/order-profit",
              controller: "OrderProfit",
              action: "index",
            },
            {
              title: i18n.t("Nav.billProfit"),
              link: "/bill-profit",
              controller: "OrderProfit",
              action: "billCostAnalyze",
            },
            {
              title: i18n.t("Nav.shopProfit", [consts.shopName()]),
              link: "/shop-profit",
              controller: "ShopProfit",
              action: "index",
            },
            {
              title: i18n.t("Nav.materialProfit"),
              link: "/material-profit",
              controller: "MaterialProfit",
              action: "index",
            },
            {
              title: i18n.t("Nav.monthlyStatisticss"),
              // icon: "fa-calendar-alt",
              link: "/monthly-statisticss",
              controller: "OrderMaterialAnalyze",
              action: "monthAnalyze",
            },
            {
              title: i18n.t("Nav.orderBacklog"),
              // icon: "fa-shopping-cart",
              link: "/order-backlog",
              controller: "OrderMaterialAnalyze",
              action: "orderBacklog",
            },
            {
              title: i18n.t("Nav.orderFreight"),
              // icon: "fa-shopping-cart",
              link: "/order-freight",
              controller: "OrderMaterialAnalyze",
              action: "orderFreight",
            },
            {
              title: i18n.t("Nav.orderCategoryFreight"),
              // icon: "fa-shopping-cart",
              link: "/order-category-freight",
              controller: "OrderMaterialAnalyze",
              action: "orderCategoryFreight",
            },
            {
              title: i18n.t("Nav.orderService"),
              // icon: "fa-shopping-cart",
              link: "/order-service",
              controller: "OrderMaterialAnalyze",
              action: "orderService",
            },
          ],
        },
        {
          title: i18n.t("Nav.store", [consts.shopName()]),
          icon: "fa-store",
          link: "/shop-daily-reports",
          subitems: [
            {
              title: i18n.t("Nav.shopDailyReports", [consts.shopName()]),
              // icon: "fa-store",
              link: "/shop-daily-reports",
              controller: "ShopDailyReports",
              action: "index",
              show: function () {
                return this.settings && this.settings.shop_inventory_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.shopCostAnalyze", [this.$consts.shopName()]),
              // icon: "fa-store",
              link: "/shop-cost-analyze",
              controller: "ShopCostAnalyze",
              action: "index",
            },
            // {
            //   title: i18n.t("Nav.materialCostAnalyze"),
            //   // icon: "fa-cube",
            //   link: "/material-cost-analyze",
            //   controller: "ShopCostAnalyze",
            //   action: "materialAnalyze",
            // },
          ],
        },

        {
          title: i18n.t("Nav.subAccountAnalyses"),
          icon: "fa-credit-card",
          link: "/sub-account-analyses",
          controller: "SubAccountAnalyses",
          action: "index",
          show: function () {
            return this.settings && this.settings.sub_account_enable;
          }.bind(this),
        },
        //分账结算查询
        {
          title: i18n.t("Nav.subAccountQuery"),
          icon: "fa-credit-card",
          link: "/sub-account-orders",
          controller: "SubAccountAnalyses",
          action: "subAccountOrders",
          show: function () {
            return this.settings && this.settings.sub_account_enable;
          }.bind(this),
        },
        //门店分账汇总
        {
          title: i18n.t("Nav.shopSubAccountSum", [consts.shopName()]),
          icon: "fa-store-alt",
          link: "/shop-sub-account-sum",
          controller: "SubAccountAnalyses",
          action: "mfSubAccount",
          show: function () {
            return (
              this.settings &&
              this.settings.sub_account_enable &&
              this.settings.push_platform == 2001
            );
          }.bind(this),
        },
        //门店销售分账汇总
        {
          title: i18n.t("Nav.alliancesSubAccounts", [
            consts.shopName(),
            consts.allianceName(),
          ]),
          icon: "fa-store-alt",
          link: "/alliance-sub-accounts",
          controller: "SubAccountAnalyses",
          action: "mfShopSale",
          show: function () {
            return this.settings && this.settings.push_platform == 2001;
          }.bind(this),
        },
        // {
        //   title: i18n.t("Nav.costAnalyze"),// 暂时假界面
        //   icon: "fa-file-contract",
        //   link: "/order-cost",
        //   subitems: [
        //     {
        //       title: i18n.t("Nav.shopCost", [consts.shopName()]),
        //       link: "/shop-cost",
        //       controller: "ShopProfit",
        //       action: "index",
        //     },
        //     {
        //       title: i18n.t("Nav.materialCost"),
        //       link: "/material-cost",
        //       controller: "MaterialProfit",
        //       action: "index",
        //     },
        //   ],
        // },
      ];
    },
    settingNavs() {
      return [];
    },
  },
};
</script>